import { set_timeout } from '@/utils/utils_client';
import { CALLBACK__void } from '@shared/types/types';
import { useState } from 'react';
import { use_effect } from '../_base/use_effect';

interface HookResult {
  is_mounted: boolean;
}

export function use_component_is_mounted(delay: number, on_mounted: CALLBACK__void = () => {}): HookResult {
  const [is_mounted, set_is_mounted] = useState(false);

  /*
   * EFFECTS
   */
  use_effect(() => {
    on_mounted();

    const timeout_id = set_timeout(() => set_is_mounted(true), delay);

    return () => {
      clearTimeout(timeout_id);
      set_is_mounted(false);
    };
  }, [delay]);

  return { is_mounted };
}
